module.exports = __webpack_public_path__ + "media/components/src/assets/images/icons/icon-entrance-3c83d33da336c9d8396302b7d7fff402.png";